import { globalJsDebug } from '../../../../public/wp-content/themes/ghwp/config/global.yaml';

export class Debuggable {
    constructor(prefix = '') {
        this.prefix = prefix;
    }

    get debug() {
        if (globalJsDebug || this?.options?.debug === true) {
            if (this.prefix) {
                return {
                    log: this._wrappedLog.bind(this),
                    warn: this._wrappedWarn.bind(this),
                    error: this._wrappedError.bind(this),
                };
            } else {
                return console;
            }
        } else {
            return {
                log() {},
                warn() {},
                error() {},
            };
        }
    }

    _wrappedLog(...args) {
        console.log(`[${this.prefix}]`, ...args);
    }

    _wrappedWarn(...args) {
        console.warn(`[${this.prefix}]`, ...args);
    }

    _wrappedError(...args) {
        console.error(`[${this.prefix}]`, ...args);
    }
}
